<template lang="html">
  <main>
    <img src="../assets/logo_color.png" alt="logo" class="logo">
    <h1>
      Register
    </h1>
    <v-form class="register-form" ref="form" v-model="valid" lazy-validation>
      <v-text-field
        class="form-input"
        ref="orgName"
        v-model="orgName"
        :rules="[v => !!v || 'Organization name is required']"
        label="Organization"
        required
        id="orgName"
      ></v-text-field>
      <v-text-field
        class="form-input"
        ref="email"
        type="email"
        v-model="email"
        :rules="emailRules"
        label="Email"
        required
        id="email"
      ></v-text-field>
      <v-text-field
        class="form-input"
        ref="password"
        type="password"
        v-model="pw"
        label="Password"
        :rules="[v => !!v || 'Password is required']"
        required
        id="password"
      ></v-text-field>
      <v-btn
        class="submit-button"
        block
        @click="register"
        :disabled="!valid"
        :loading="loading"
      >Create Account</v-btn>
      <p v-if="registrationError" class="error">{{ registrationError.msg || registrationError }}</p>
    </v-form>
  </main>
</template>

<script>
export default {
  name: 'RegisterForm',
  props: [ 'registrationError' ],
  data() {
    return {
      valid: true,
      orgName: '',
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /@/.test(v) || 'E-mail must be valid',
      ],
      pw: '',
      loading: false,
    };
  },
  methods: {
    async register() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        await this.$store.dispatch('users/register', {
          orgName: this.$refs.orgName.value,
          email: this.$refs.email.value,
          password: this.$refs.password.value,
        });
        if (!this.registrationError) {
          this.$router.push('/welcome');
        }
      }
      this.loading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ../shared/components/RegisterForm.vue